export const rules = {
  login_name: [
    { required: true, message: "登录账号", trigger: "change" },
  ],
  name: [
    { required: true, message: "姓名", trigger: "change" },
  ],
  pwd: [
    { required: true, message: "登录密码", trigger: "change" },
  ],
  mobile: [
    { required: true, message: "电话", trigger: "change" },
  ]
}